module.exports = __webpack_public_path__ + "img/CompScope_Space_05.dcd33493.png";